import React, {CSSProperties, ReactNode} from 'react';
import {Link} from 'react-router';
import classNames from 'classnames';
import 'styles/utils/Breadcrumbs.styl';

export interface BreadcrumbLink {
  // display name of the link
  // Yes, this can really be a node. See, for example, getTeamSelectorLink in DashboardBreadcrumbs.
  name: ReactNode;
  // url of the link, usually undefined, for the final breadcrumb
  url?: string;
  // query params to append
  query?: {[index: string]: string | string[] | null};
  // link state
  state?: any;
  // icon to display next to breadcrumb
  icon?: ReactNode;
}

interface Props {
  // custom class name to be added to the top div
  className?: string;
  // array of objects with link information
  links: BreadcrumbLink[];
  onClickLink?: (name: ReactNode) => void;
  style?: CSSProperties;
}

export default class Breadcrumbs extends React.Component<Props> {
  onClickLink = (name: ReactNode) => {
    if (this.props.onClickLink) {
      this.props.onClickLink(name);
    }
  };

  render() {
    // get breadcrumbs class
    const className = classNames(this.props.className, 'breadcrumbs');

    // the breadcrumbs are rendered as a div containing Link elements,
    // the separators are styled with CSS
    return (
      <div className={className} style={this.props.style}>
        {this.props.links.map((link, i) => {
          const className = classNames('link', {
            'link-internal': i < this.props.links.length - 1,
          });

          return link.url ? (
            <Link
              key={i}
              to={{
                pathname: link.url,
                query: link.query || {},
                state: link.state,
              }}
              className={className}
              onClick={() => this.onClickLink(link.name)}>
              {link.icon} {link.name}
            </Link>
          ) : (
            <span key={i} className={className}>
              {link.icon} {link.name}
            </span>
          );
        })}
      </div>
    );
  }
}
